module.exports = __webpack_public_path__ + "img/section3Card2BrandIcon7.3d53710a.png";